<template>
	<div class="h-100 ab-lv pb-0 px-3">
		<b-table-simple responsive class="mb-0">
			<b-thead class="ab-lv-header" v-if="$route.name == 'assetbank'">
				<b-tr>
					<b-th style="width: 40%" class="pl-4">
						<span class="d-flex align-items-center pointer">
							File Name
							<template v-if="sortBy === 'title'">
								<img
									@click="applySort('title')"
									v-show="sortBy == 'title' && order === 1"
									class="pointer ml-2"
									src="@/assets/question-bank/sort-data.svg"
									alt="asc"
								/>
								<img
									@click="applySort('title')"
									v-show="sortBy == 'title' && order === -1"
									class="pointer ml-2"
									src="@/assets/question-bank/asce-sort.svg"
									alt="desc"
								/>
							</template>
							<template v-else>
								<img
									class="pointer ml-2"
									src="@/assets/question-bank/no-sort.svg"
									alt=""
									@click="applySort('title')"
								/>
							</template>
						</span>
					</b-th>

					<b-th style="width: 10%">
						<span class="d-flex align-items-center pointer">
							File Size

							<template v-if="sortBy === 'assetSize.sizeInBytes'">
								<img
									@click="applySort('assetSize.sizeInBytes')"
									v-show="sortBy == 'assetSize.sizeInBytes' && order === 1"
									class="pointer ml-2"
									src="@/assets/question-bank/sort-data.svg"
									alt="asc"
								/>
								<img
									@click="applySort('assetSize.sizeInBytes')"
									v-show="sortBy == 'assetSize.sizeInBytes' && order === -1"
									class="pointer ml-2"
									src="@/assets/question-bank/asce-sort.svg"
									alt="desc"
								/>
							</template>
							<template v-else>
								<img
									class="pointer ml-2"
									src="@/assets/question-bank/no-sort.svg"
									alt=""
									@click="applySort('assetSize.sizeInBytes')"
								/>
							</template>
						</span>
					</b-th>

					<!-- Uploaded Date -->
					<b-th style="width: 13%" class="d-flex">
						<span class="d-flex align-items-center pointer">
							Uploaded Date
						</span>
						<template v-if="sortBy === 'createdAt'">
							<img
								@click="applySort('createdAt')"
								v-show="sortBy == 'createdAt' && order === 1"
								class="pointer ml-2"
								src="@/assets/question-bank/sort-data.svg"
								alt="asc"
							/>
							<img
								@click="applySort('createdAt')"
								v-show="sortBy == 'createdAt' && order === -1"
								class="pointer ml-2"
								src="@/assets/question-bank/asce-sort.svg"
								alt="desc"
							/>
						</template>
						<template v-else>
							<img
								class="pointer ml-2"
								src="@/assets/question-bank/no-sort.svg"
								alt=""
								@click="applySort('createdAt')"
							/>
						</template>
					</b-th>

					<b-th style="width: 30%">Tags</b-th>
					<b-th style="width: 10%">Actions</b-th>
				</b-tr>
			</b-thead>
		</b-table-simple>

		<Shimmer :gridView="false" v-if="loaderStatus" />
		<template
			v-if="!assets.length && !searchQuery && $route.name === 'assetbank'"
		>
			<section
				class="w-100 h-100 d-flex justify-content-center align-items-center flex-column"
			>
				<img src="@/assets/asset-bank/noassetsadded.svg" />
				<span class="no-data-txt mt-3 ml-3 text-center"
					>No {{ tabText }} have been added,<br />
					click "+ file" button to upload the {{ tabText }}s
				</span>
				<PButton
					class="mt-3 ml-3"
					:type="'add'"
					text="File"
					@clicked="$emit('openModal')"
				/>
			</section>
		</template>
		<template
			v-else-if="
				(!assets.length && searchQuery) ||
				(!assets.length && !searchQuery && $route.name !== 'assetbank')
			"
		>
			<section
				class="h-80 d-flex align-items-center flex-column justify-content-center"
				v-if="!assets.length"
			>
				<img src="@/assets/common/no-data-found.svg" alt="" />
				<p
					class="fs-14 fw-500 font-secondary fc-black"
					v-if="
						(!assets.length && searchQuery) ||
						($route.name === 'assetbank' &&
							!assets.length &&
							selectedTab != 0 &&
							!loaderStatus)
					"
				>
					No matching results
					<span v-if="searchQuery"> for"{{ searchQuery }}" </span>
				</p>
				<p
					class="fs-14 fw-500 font-secondary fc-black"
					v-if="!assets.length && !searchQuery && $route.name !== 'assetbank'"
				>
					No Data Found
				</p>
			</section>
		</template>

		<b-table-simple
			v-else-if="assets.length && !loaderStatus"
			class="ab-lv-bodytable"
			:class="{
				'overflow-auto list-view-height': $route.name == 'assetbank',
			}"
			responsive
		>
			<b-tbody>
				<b-tr
					class="ab-lv-bodycards mt-2"
					v-for="(asset, index) in assets"
					:class="{
						pointer: isCreation,
						'ab-lv-bodycards-selection': selectedAssetID == asset.assetID,
					}"
					@click="(hideView = false), selectAsset(asset)"
					:key="index"
				>
					<b-th style="width: 40%" class="position-relative">
						<div class="blueline position-absolute"></div>
						<div class="d-flex align-items-center pl-2">
							<div
								class="rounded"
								style="height: 24px; width: 27px"
								v-if="asset.assetType == '1'"
							>
								<div v-if="asset.assetThumbnail" class="position-relative">
									<img
										class="rounded overflow-hidden position-absolute lv-nothumb-img"
										style="height: 24px; width: 27px"
										src="@/assets/asset-bank/listview/list-view-no-thumbnail.svg"
										alt=""
									/>
									<img
										class="rounded overflow-hidden"
										style="height: 24px; width: 27px"
										:src="asset.assetThumbnail"
										alt=""
									/>
								</div>

								<img
									v-else-if="!asset.assetThumbnail"
									class="rounded overflow-hidden"
									style="height: 24px; width: 27px"
									src="@/assets/asset-bank/listview/list-view-play-button.svg"
									alt=""
								/>
							</div>
							<img
								v-else-if="asset.assetType == '2'"
								class="rounded"
								src="@/assets/asset-bank/listview/list-ppt.svg"
								alt=""
							/>
							<img
								style="height: 25px; width: 27px"
								v-else-if="asset.assetType == '3'"
								class="rounded"
								:src="asset.asset"
								alt=""
							/>
							<img
								v-else-if="asset.assetType == '4'"
								class="rounded"
								src="@/assets/asset-bank/listview/pdf.svg"
								alt=""
							/>
							<img
								v-else-if="asset.assetType == '5'"
								class="rounded"
								src="@/assets/asset-bank/listview/list-notes.svg"
								alt=""
							/>
							<img
								v-else-if="asset.assetType == '8'"
								class="rounded"
								src="@/assets/asset-bank/listview/list-zip.svg"
								alt=""
								style="height: 24px; width: 27px;"
							/>
							<img
								v-else-if="asset.assetType == '6'"
								class="rounded"
								src="@/assets/asset-bank/listview/list-link.svg"
								alt=""
							/>
							<div class="pl-3" style="word-break: break-word">
								{{ asset.title }}
							</div>
						</div>
					</b-th>
					<b-th style="width: 10%" v-if="asset.assetSize.actualSize">{{
						asset.assetSize.actualSize
					}}</b-th>
					<b-th style="width: 10%" v-else></b-th>

					<b-th style="width: 10%">{{ formatDate(asset.updatedAt) }}</b-th>

					<b-th style="width: 30%" v-if="asset.tags.length === 0">-</b-th>
					<b-th style="width: 30%" v-else>
						<span v-for="(tag, index) in asset.tags.slice(0, 3)" :key="index">
							<span class="ab-lv-tags ml-1">{{ tag }}</span>
						</span>

						<div
							v-if="asset.tags.length > 3"
							style="
								display: inline-block;
								position: relative;
								cursor: pointer;
								text-align: center;
							"
						>
							<span :id="'tooltiptags' + index" class="ab-lv-tags ml-1">
								+{{ asset.tags.length - 3 }}
							</span>

							<b-tooltip
								:target="'tooltiptags' + index"
								placement="bottom"
								boundary="window"
								triggers="hover focus"
								custom-class="custom-tooltip-unique custom-section-width custom-left"
								:delay="{ show: 200, hide: 200 }"
							>
								{{ asset.tags.join(", ") }}
							</b-tooltip>
						</div>
					</b-th>
					<b-th class="d-flex align-items-center justify-content-around">
						<img
							v-if="!isCreation"
							class="pointer"
							src="@/assets/common/edit.svg"
							@click="editOrViewAsset(asset, index)"
							alt=""
						/>
						<img
							v-if="!isCreation"
							@click="(showDelete = true), (showDetails = asset)"
							src="@/assets/common/delete.svg"
							alt=""
							class="pointer"
						/>
						<img
							@click.stop="
								(selectedAssetID = null),
									(hideView = true),
									handleAssetClick(asset, index)
							"
							src="@/assets/common/view-icon.svg"
							alt=""
							class="pointer"
						/>
					</b-th>
				</b-tr>
			</b-tbody>
		</b-table-simple>

		<b-modal id="editnote" centered hide-footer title="Edit Note" size="lg">
			<section class="position-absolute viewimage-header-icons mr-2">
				<img
					class="rotate-on-hover"
					src="@/assets/common/blue-cross.svg"
					alt=""
				/>
			</section>
			<section class="p-3">
				<Notes />
			</section>
			<hr />
			<div class="d-flex justify-content-end align-items-center px-3 pb-3">
				<OButton text="Cancel" class="p1-15" />
				<PButton class="ml-2 p1-15" text="Update" />
			</div>
		</b-modal>
		<ViewLink
			v-if="viewLink"
			:editAsset="editAsset"
			:viewLink="viewLink"
			:showDetails="showDetails"
			:validation="$v.showDetails"
			@changeVal="changeVal"
			@closeModal="closeModal"
			@handle-save="saveEditedAsset('viewLink')"
			:loading="showLoader"
		/>
		<ViewFile
			@handle-get="getMethod"
			@getThumbnail="getThumbnail"
			:viewFile="viewFile"
			@deleteFile="deleteFile"
			:showDetails="showDetails"
			:validation="$v.showDetails"
			:editFile="editFile"
			@closeModal="closeModal"
			@fileUploaded="fileUploaded"
			:thumbnailPresent="thumbnailPresent"
			@changeVal="changeVal"
			@handle-save="saveEditedAsset('viewFile')"
			:errorFile="errorFile"
			:loading="showLoader"
		/>
		<DeleteModal
			:loading="showLoader"
			@handle-delete="deleteAsset('showDelete')"
			:showDelete="showDelete"
			@closeModal="closeModal"
			:headtext="'Delete'"
			:summarytext="'Are you sure you want to delete the item?'"
		/>
		<ViewImage
			@handle-get="getMethod"
			:loading="showLoader"
			:viewImage="viewImage"
			:showDetails="showDetails"
			:validation="$v.showDetails"
			:editImage="editImage"
			@changeVal="changeVal"
			@closeModal="closeModal"
			:errorFile="errorFile"
			@fileUploaded="fileUploaded"
			@handle-save="saveEditedAsset('viewImage')"
		/>
		<ViewNotes
			:loading="showLoader"
			:viewNotes="viewNotes"
			:showDetails="showDetails"
			:validation="$v.showDetails"
			:editNotes="editNotes"
			@changeVal="changeVal"
			@closeModal="closeModal"
			@handle-save="saveEditedAsset('viewNotes')"
		/>
		<div v-if="showlazyLoading" class="d-flex justify-content-center">
			<b-spinner label="Loading..."></b-spinner>
		</div>
	</div>
</template>

<script>
import assetMixins from "@/views/asset-bank/mixins/assetMixins";

export default {
	mixins: [assetMixins],
	name: "ListView",
	props: {
		selectedAsset: Object,
	},
	data() {
		return {
			sortBy: null,
			order: 1,
		};
	},
	methods: {
		applySort(field) {
			if (this.sortBy === field) {
				this.order = this.order === 1 ? -1 : 1;
			} else {
				this.sortBy = field;
				this.order = 1;
			}
			this.$emit("handle-get", {
				sortBy: this.sortBy,
				order: this.order,
			});
		},
	},

	created() {
		this.selectedAssetID = this.selectedAsset?.assetID;
	},
};
</script>

<style>
.table th,
.table td {
	border-top: unset;
}
.table thead th {
	border-bottom: unset;
}
.ab-lv-bodytable table {
	border-collapse: separate;
	border-spacing: 0 var(--size-10);
}
.ab-lv .ab-lv-header {
	height: 45px;
	background: #e9f0f5;
	border-radius: var(--size-5);
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-600);
	font-size: var(--size-14);
	color: #20639b;
	white-space: nowrap;
}
.ab-lv .ab-lv-bodycards {
	height: 45px;
	background: linear-gradient(0deg, #ffffff, #ffffff), #fcfcfc;
	box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
	border-radius: var(--size-5);
	font-family: "Lato", sans-serif;
	font-size: var(--size-14);
	color: #20639b;
}
.ab-lv .ab-lv-bodycards th {
	font-weight: var(--weight-600);
}
.blueline {
	height: 90%;
	width: 3.5px;
	background: #20639b;
	top: 3px;
	left: 5px;
	border-radius: var(--size-10);
}
.ab-lv-tags {
	padding: 4px 6px;
	font-family: "Montserrat", sans-serif;
	font-weight: var(--weight-R);
	font-size: 12px;
	color: #20639b;
	background: #f1f7ff;
	border-radius: 14.7861px;
}
.view-image-container {
	height: 250px;
}

.close {
	display: none;
}
.b-form-tags.form-control .close {
	display: block;
}
/*
.close:not(:disabled):not(.disabled):hover,
.close:not(:disabled):not(.disabled):focus {
	opacity: unset;
} */
.ei-icons {
	top: 2px;
	right: 12px;
}
.en-list-desc li {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-R);
	font-size: 16px;
	text-align: justify;
	color: #565656;
}
.en-list-desc {
	max-height: 350px;
	min-height: auto;
	overflow: auto;
	padding-inline-start: 5px;
}
.viewlink-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: var(--size-5);
	padding: var(--size-10);
}
.viewlinkcard-heading {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-R);
	font-size: var(--size-15);
	color: #20639b;
}
.viewlinkcard-subheading {
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-R);
	font-size: 13px;
	color: rgba(51, 51, 51, 0.5);
}
.ab-right-line {
	border-right: 2px solid #c4c4c466;
}
.lv-nothumb-img {
	top: 0;
	left: 0;
}
.ab-lv-bodycards-selection {
	background: #e1eef7 !important;
}
.list-view-height {
	height: calc(100vh - 340px);
}
.custom-left {
	top: 2px !important;
	left: -21px !important;
}
</style>
